import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRotate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.992 12.032a7.97 7.97 0 0 1-2.335 5.625 8 8 0 0 1-11.314 0 8 8 0 0 1-1.366-1.831M4.004 11.87a7.97 7.97 0 0 1 2.339-5.527 8 8 0 0 1 11.314 0 8 8 0 0 1 1.366 1.831"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.953 8.175h3.535V4.639M8.047 15.825H4.512v3.536"
    />
  </svg>
);
export default SvgArrowRotate;
